// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2Fzwi","normal":"Logo_normal__1SpUU","compact":"Logo_compact__1DiDy"};